export function updateCurrentYear() {
  const currentYear = new Date().getFullYear();
  const currentYearElems = document.querySelectorAll(".current-year");
  if (currentYearElems.length > 0) {
    currentYearElems.forEach((element) => {
      element.textContent = currentYear.toString();
    });
  }
}
